import { useSupervisorAccess } from "@/app/hook/use-supervisor-access";
import type { SupervisorGuardProps } from "../types/index";

export const SupervisorGuard = ({
  children,
  fallback = null,
  allowInDelegatedView = false,
}: SupervisorGuardProps) => {
  const { canMutate } = useSupervisorAccess();

  if (allowInDelegatedView || canMutate) {
    return <>{children}</>;
  }

  return <>{fallback}</>;
};
